import { format, formatDistanceToNow, parseISO } from 'date-fns'
import { FC, useMemo } from 'react'

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

type Props = {
  date: string | Date
  side?: 'left' | 'top' | 'right' | 'bottom'
  className?: string
}

const RelativeDate: FC<Props> = ({ date, side = 'right', className }) => {
  const { fullDate, relativeDate } = useMemo(() => {
    const parsedDate = typeof date === 'string' ? parseISO(date) : date
    const isOver30Days = new Date().getTime() - parsedDate.getTime() > 30 * 24 * 60 * 60 * 1000
    const relativeDate = isOver30Days
      ? format(parsedDate, 'MMM d, yyyy')
      : formatDistanceToNow(parsedDate, { addSuffix: true })
    return {
      fullDate: format(parsedDate, 'MMM d, yyyy h:mma').replace(/AM$/, ' am').replace(/PM$/, ' pm'),
      relativeDate,
    }
  }, [date])

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger className={className}>{relativeDate}</TooltipTrigger>
        <TooltipContent side={side}>{fullDate}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default RelativeDate
